import React, { useState } from "react";
import { useSendToVoicemailAction } from "../../hooks/useCallAction";
import SendToVoicemailUI from "./SendToVoicemailUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

/**
 * SendToVoicemail component - can be used for root or off-hours contexts
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const SendToVoicemail = ({ 
  setOpenConfigureSlotModal, 
  route, 
  setRoute,
  context = 'root',
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localRecordings] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );
  const recordings = routeModals?.recordings ?? localRecordings;
  const sendToVoicemailLogic = useSendToVoicemailAction(context, route, setRoute);
  const addRecordingOption = routeModals
    ? { label: "Add Recording", onClick: () => routeModals.openAddRecordingModal(sendToVoicemailLogic.handleRecordingChange) }
    : undefined;

  return (
    <SendToVoicemailUI
      {...sendToVoicemailLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      recordings={recordings}
      hasValidationError={hasValidationError}
      addRecordingOption={addRecordingOption}
    />
  );
};

export default SendToVoicemail;
